import { getAuth } from 'firebase/auth';
import firebase from 'firebase/compat/app';

import { auth, providers } from '@/common/data/firebase/firebase.ts';
import { logException } from '@/common/utils/logger';


export const apiLoginUser = async(email: string, password: string) => {
    const userCredential = await auth.signInWithEmailAndPassword(email, password) as firebase.auth.UserCredential;

    if (userCredential.user?.emailVerified === false) {
        throw new Error('authentication.emailNotVerified');
    }

    // Set persistence and wait for it to complete
    await auth.setPersistence('local');

    const accessToken = await userCredential.user?.getIdToken(true) as string;
    return { token: accessToken, user: userCredential.user};
};
  
export const apiRegisterUser = async(email: string, password: string) => {
   
    try {
        const userCredential = await auth.createUserWithEmailAndPassword(email, password) as firebase.auth.UserCredential;
        await userCredential.user?.sendEmailVerification();

        const accessToken = await userCredential.user?.getIdToken(true) as string;

        // Set persistence and wait for it to complete
        await auth.setPersistence('local');
        return { token: accessToken };
    } catch (error: any) {
        logException(error);
        throw Error(error);
    }
};

export const apiLogoutUser = async () => {
    try {
        await auth.signOut();
    } catch (error) {
        logException(error);
        throw error;
    }
};

// A function to handle the redirect flow
export const apiHandleRedirect = async () => {
    const result = await auth.getRedirectResult();
    return result;
};

export const apiLoginWithRedirect = async (authProvider: string) => {
    let selectedProvider;

    switch (authProvider) {
        case 'google':
            selectedProvider = providers.google;
            break;
        case 'facebook':
            selectedProvider = providers.facebook;
            break;
        case 'apple':
            selectedProvider = providers.apple;
            break;
        default:
            selectedProvider = providers.google;
            break;
    }

    await auth.signInWithRedirect(selectedProvider);

    const result = await apiHandleRedirect();

    const credential = result.credential as firebase.auth.OAuthCredential;

    const token = credential.accessToken as string;

    await auth.setPersistence('local');

    return { token };
};

export const renewToken = async () => {
    const user = auth.currentUser as firebase.User;
    const token = await user.getIdToken();
    return token;
};

// A function to handle login persistence (e.g., when the user refreshes the page) and check on the user's authentication state
export const apiCheckAuthState = async () => {

    const auth = getAuth();
    const user = auth.currentUser;

    if (user !== null) {
        const token = await user.getIdToken(); // fb method
        return token;
    } else {
        return null;
    }
};
